import { render, staticRenderFns } from "./currency-rule.vue?vue&type=template&id=f6c5dfb0&scoped=true&"
import script from "./currency-rule.vue?vue&type=script&lang=js&"
export * from "./currency-rule.vue?vue&type=script&lang=js&"
import style0 from "./currency-rule.vue?vue&type=style&index=0&id=f6c5dfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c5dfb0",
  null
  
)

export default component.exports